import { userCustomTourOperatoreCode as userCustomTOPCodeSessionKey } from '../../config/sessionStorage'

import {
  userHasCustomTourOperatorCode,
  userCustomTourOperatoreCode,
} from '../../utils/tourOperators'

import {
  v1requestChangeUserCustomTOPCode,
  v1receiveUser,
} from '../../actions/users'
import { V1_REQUEST_USER } from '../../actions/users/v1requestUser'
import { V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE } from '../../actions/users/v1setUserCustomTOPCodeFromSessionStore'
import { V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE } from '../../actions/users/v1requestChangeUserCustomTOPCode'
import v1throwError from '../../actions/errors/v1throwError'
import { msalInstance } from '../../msalClient'
import User from '../../models/User'

export default store => next => async action => {
  next(action)

  try {
    switch (action.type) {
      case V1_REQUEST_USER:
        requestUser(store)
        break
      case V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE:
        storeUserCustomTOPCode(action)
        break
      case V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE:
        fetchUserCustomTOPCodceFromSessionStorage(store)
        break
      default:
        break
    }
  } catch (error) {
    store.dispatch(v1throwError(error))
  }
}

const requestUser = async store => {
  const dispatch = store.dispatch

  const account = msalInstance.getActiveAccount()

  if (account) {
    dispatch(v1receiveUser(new User(account)))
  } else {
    dispatch(v1throwError("No user logged in!"))
  }
}

const storeUserCustomTOPCode = action => {
  sessionStorage[userCustomTOPCodeSessionKey] = action.data
}

const fetchUserCustomTOPCodceFromSessionStorage = store => {
  const dispatch = store.dispatch

  const TOPCode = userHasCustomTourOperatorCode()
    ? userCustomTourOperatoreCode()
    : undefined

  dispatch(v1requestChangeUserCustomTOPCode(TOPCode))
}
